import { render, staticRenderFns } from "./AboutInfo.vue?vue&type=template&id=dca0aa14"
import script from "./AboutInfo.vue?vue&type=script&lang=js"
export * from "./AboutInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports